/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_CloseInputs */

const en_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const ar_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const he_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const ur_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const es_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const fr_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const de_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const pt_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const hi_ui_close = en_ui_close;

/** @type {(inputs: Ui_CloseInputs) => LocalizedString} */
const bn_ui_close = en_ui_close;

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Ui_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_close = /** @type {((inputs?: Ui_CloseInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_CloseInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_close(inputs)
	if (locale === "he") return he_ui_close(inputs)
	if (locale === "ur") return ur_ui_close(inputs)
	if (locale === "es") return es_ui_close(inputs)
	if (locale === "fr") return fr_ui_close(inputs)
	if (locale === "de") return de_ui_close(inputs)
	if (locale === "pt") return pt_ui_close(inputs)
	if (locale === "hi") return hi_ui_close(inputs)
	if (locale === "bn") return bn_ui_close(inputs)
	return /** @type {LocalizedString} */ ("Close")
});